export default "__VITE_PUBLIC_ASSET__cbe6e3ce__"